// Portfolio Diagnostic App - Dual Mode (Consumer + Advisor)
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppModeProvider } from "@/contexts/AppModeContext";
import { PartnerProvider } from "@/contexts/PartnerContext";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Analytics from "./pages/Analytics";
import SessionRecording from "./pages/SessionRecording";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PartnerProvider>
        <AppModeProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AnalyticsProvider enableSessionRecording={true} enableAutoClickTracking={true}>
              <Routes>
                <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/observations" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/model" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/holdings" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/learn" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/accounts" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/privacy" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/tools" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/advisor-tools" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                <Route path="/analytics/recording/:sessionId" element={<ProtectedRoute><SessionRecording /></ProtectedRoute>} />
                <Route path="/auth" element={<Auth />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              </AnalyticsProvider>
            </BrowserRouter>
          </TooltipProvider>
        </AppModeProvider>
        </PartnerProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
